import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import {React, useRef, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext/AuthContext";
import { api_Routes } from "../../api_Routes";
import { Helper } from "../../tools/Helper";
import { Styles } from "./styles";
import { InputAdornment } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";

const AddPanel = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { auth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [IsLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    smmpanel_name: "",
    smmpanel_url: "",
    description: "",
    smmpanel_email: "",
    smmpanel_instagram: "",
    smmpanel_skybe: "",
    smmpanel_telegram: "",
    smmpanel_fb: "",
    smmpanel_twitter: "",
    smmpanel_whatsapp: "",
    smmpanel_tel1: "",
    customLogo: "",
    logo: null,
    reading_type: "",
    url_service: "",
    loginpassword: "",
    loginuser: "",
    api_key: "",
    api_url: "",
    country_id: "",
  });

  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);


  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const [uploadSliderOption, setUploadSliderOption] = useState("uploadImages");

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };
  const handleButtonClick = async () => {
    // if (!auth) {
    //   enqueueSnackbar("please login first ", { variant: "warning" });
    //   navigate("/login", { state: { from: location } });
    // } else {
      await handleSubmit();
    // }
  };
  const handleSubmit = async () => {
    if (!captchaToken) {
      enqueueSnackbar("Please complete the CAPTCHA", {variant: "error"});
      return;
    }
    const requiredFields = ["smmpanel_url","smmpanel_email","smmpanel_whatsapp"];

    const updatedFormData = {
      ...formData,
    };

    const missingFields = requiredFields.filter(
      (field) => !updatedFormData[field]
    );

    if (uploadSliderOption === "enterUrls") {
      if (
        !updatedFormData.screenshot_urls ||
        updatedFormData.screenshot_urls.length === 0
      ) {
        updatedFormData.screenshot_urls =
          formData.smmpanel_url?.split(",").map((url) => url.trim()) || [];
      }
    } else if (uploadSliderOption === "uploadImages") {
      if (!updatedFormData.photos || updatedFormData.photos.length === 0) {
        updatedFormData.screenshot_urls =
          formData.smmpanel_url?.split(",").map((url) => url.trim()) || [];
      }
    }

    if (missingFields.length > 0) {
      enqueueSnackbar(
        `Please fill in all required fields: ${missingFields.join(", ")}`,
        {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        }
      );
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const form_data = new FormData();

    // Append other form data fields
    Object.keys(updatedFormData).forEach((key) => {
      const value = updatedFormData[key];
      if (key !== "logo" && key !== "customLogo") {
        if (key === "screenshot_urls") {
          // Append screenshot_urls as an array if it exists
          if (value.length > 0) {
            value.forEach((url, index) => {
              form_data.append(`screenshot_urls[${index}]`, url);
            });
          } else {
            form_data.append("screenshot_urls", ""); // Append empty string if array is empty
          }
        } else if (formData[key] !== "" && formData[key] !== null)
          form_data.append(key, updatedFormData[key]);
      }
    });

    const { response, message } = await Helper.Post({
      url: api_Routes.AddPanel.add,
      data: form_data,
      hasToken: true,
    });

    if (response) {
      enqueueSnackbar(message, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      navigate("/");
      setIsLoading(false);
    } else {
      let errorMessage = "";
      if (typeof message === "string") {
        errorMessage = message;
      } else if (typeof message === "object") {
        errorMessage = Object.values(message).flat().join(", ");
      }
      enqueueSnackbar(errorMessage, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };

  const formStyles = {
    sectionTitle: {
      color: "#2d3748",
      fontWeight: 600,
      fontSize: "1.5rem",
      mb: 3,
    },
    textField: {
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        "& fieldset": { borderColor: "#e2e8f0" },
        "&:hover fieldset": { borderColor: "#cbd5e0" },
        "&.Mui-focused fieldset": { borderColor: "#3b82f6" },
      },
      "& .MuiInputLabel-root": {
        color: "#718096",
        fontSize: "0.875rem",
      },
      "& .MuiInputBase-input": {
        fontSize: "0.875rem",
        padding: "12px 14px",
      },
    },
    submitButton: {
      background: "linear-gradient(45deg, #3b82f6 30%, #60a5fa 90%)",
      color: "white",
      fontWeight: 600,
      fontSize: "1rem",
      px: 6,
      py: 1.5,
      borderRadius: "8px",
      boxShadow: "0 4px 6px -1px rgba(59, 130, 246, 0.2)",
      "&:hover": {
        boxShadow: "0 10px 15px -3px rgba(59, 130, 246, 0.3)",
      },
    },
  };
  return (
    <Styles>
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: "#1e293b",
              mb: 2,
              fontSize: { xs: "2rem", md: "2.5rem" },
            }}
          >
            Add Your Own Panel
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#64748b",
              maxWidth: 600,
              mx: "auto",
              fontSize: "1.1rem",
            }}
          >
            Expand your reach by adding your panel to our comprehensive database
          </Typography>
        </Box>

        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 3,
            p: { xs: 3, md: 4 },
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Main Details Section */}
          <Box mb={5}>
            <Typography sx={formStyles.sectionTitle}>
              Panel Information
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Panel URL"
                  variant="outlined"
                  required
                  onChange={(e) => handleChange("smmpanel_url", e.target.value)}
                  sx={formStyles.textField}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <span style={{ color: "#64748b" }}>https://</span>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Contacts Section */}
          <Box mb={5}>
            <Typography sx={formStyles.sectionTitle}>
              Contact Details
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Email"
                  variant="outlined"
                  required
                  onChange={(e) =>
                    handleChange("smmpanel_email", e.target.value)
                  }
                  sx={formStyles.textField}

                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="WhatsApp"
                  variant="outlined"
                  required
                  onChange={(e) =>
                    handleChange("smmpanel_whatsapp", `+${e.target.value}`)
                  }
                  sx={formStyles.textField}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <span style={{ color: "#64748b" }}>+</span>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Telegram"
                  variant="outlined"
                  onChange={(e) =>
                    handleChange("smmpanel_telegram", `+${e.target.value}`)
                  }
                  sx={formStyles.textField}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <span style={{ color: "#64748b" }}>@</span>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px",
              }}
          >
            <ReCAPTCHA
                sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
                ref={recaptchaRef}
            />
          </Box>

          {/* Submit Button */}
          <Box textAlign="center" mt={6}>
            <Button
              variant="contained"
              onClick={handleButtonClick}
              disabled={IsLoading}
              sx={formStyles.submitButton}
            >
              {IsLoading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Submit Panel"
              )}
            </Button>
          </Box>
        </Box>
      </Container>
    </Styles>
  );
};

export default AddPanel;
